export default "__VITE_ASSET__B54sdHD9__"